/**
 * services/_demo/demoMode.ts
 * Set true by the boot gate when the platform session can't be reached at all
 * (local dev / offline). While on, every service returns the demo seed directly
 * instead of calling the API — so the whole app is coherent (no auth 401s, no
 * empty screens) without a backend. In production the platform is reachable, so
 * this is never enabled and the real API is always used.
 */
let demo = false;

export const setDemoMode = (on: boolean): void => {
  demo = on;
};

export const isDemoMode = (): boolean => demo;
